export enum PaginationCTAType {
    Next = 'NEXT',
    Previous = 'PREVIOUS',
    PageNumber = 'PAGE_NUMBER',
}

export type PaginationItem = {
    paginationCtaType: PaginationCTAType;
    currentPageNumber: number;
    clickedPageNumber: number;
};
